// src/app/services/permissions/ability.js
import { AbilityBuilder, createMongoAbility } from '@casl/ability';
import Permissions, { AdditionalRules } from 'config/permissions';
import { useSelector } from 'react-redux';

export const ability = createMongoAbility();

const extract = (can, rule) => {
  if (Array.isArray(rule)) {
    can(rule[0], rule[1]);
  } else {
    can('access', rule); // legacy fallback, still safe
  }
};

export const defineRulesFor = (auth) => {
  const { can, cannot, rules } = new AbilityBuilder();

  // Global permissions
  Permissions.all.forEach(rule => extract(can, rule));

  // Conditional permissions
  AdditionalRules.forEach(([action, subject]) => {
    let isAllowed = false;

    switch (subject) {
      case 'auth:client':
        isAllowed = !!auth?.user?.company;
        break;
      default:
        break;
    }

    if (isAllowed) {
      can(action, subject);
    } else {
      cannot(action, subject);
    }
  });
  

  // Role-specific permissions
  const roleRules = Permissions[auth?.user?.role] || [];
  roleRules.forEach(rule => extract(can, rule));

  // Tag the role
  if (auth?.user?.role) {
    can('access', auth.user.role);
  }

  console.log('ROOT: Rules', rules)
  return rules;
};

